import { z } from 'zod';

/** Body for `POST /v1/me/delete`. Reason is optional free-text feedback. */
export const deleteAccountInputSchema = z.object({
  reason: z.string().max(1000).optional(),
});

/** Response for `POST /v1/me/reset-test-data` (allowlisted emails only). */
export const resetTestDataResponseSchema = z.object({
  reset: z.literal(true),
});

export type ResetTestDataResponse = z.infer<typeof resetTestDataResponseSchema>;

export type DeleteAccountInput = z.infer<typeof deleteAccountInputSchema>;

export const accountDeletionStatusSchema = z.enum(['requested', 'processing', 'completed']);

export type AccountDeletionStatus = z.infer<typeof accountDeletionStatusSchema>;

/** Response body for `POST /v1/me/delete`. */
export const accountDeletionSchema = z.object({
  status: accountDeletionStatusSchema,
  requestedAt: z.string(),
});

export type AccountDeletion = z.infer<typeof accountDeletionSchema>;
